import BioContent from "./Bio-content";
export default BioContent;
